export default __webpack_public_path__ + "41a5bdc95e0489952227bee9aa75b23a.svg";